module.exports = __webpack_public_path__ + "img/mdiCodeBlockTags.b6fad8dc.svg";